import React from 'react'
import { CustomFormFloating } from '../../../../custom-form-floating/CustomFormFloating'

export const UserProfileData = ({userInfo,editInput = true}) => {
    return (
        <div className="user-profile">


            {userInfo?.name &&
                <CustomFormFloating
                    status={editInput}
                    type={'text'}
                    className={'editable-admin-input'}
                    label={'Nombre/s:'}
                    // value={userInfo.name}
                    labelClassName={'active-label'}
                    name={'userName'}
                >
                    <>
                        <span id="userName" className="editable-1">{userInfo?.name}</span>

                        <label className="active-label-1 class-hidden-none" htmlFor="userName">Nombre/s:</label>
                    </>

                </CustomFormFloating>}



            {userInfo?.lastname &&
                <CustomFormFloating
                    status={editInput}
                    type={'text'}
                    className={'editable-admin-input'}
                    label={'Apellido/s:'}
                    labelClassName={'active-label'}
                    value={'Diaz'}
                >
                    <>
                        <span id="userLastName" className="editable-1 e1-lastName">{userInfo.lastname}</span>

                        <label className="active-label-1 class-hidden-none" htmlFor="userLastName">Apellido/s:</label>
                    </>

                </CustomFormFloating>
            }




        </div>
    )
}
